import { Image } from 'ui/fields/Photo/components/PhotoSelector';
import { apiCall } from "../utils/api"

export type GetImageListRequest = {
   hotelId?: number
   size?: number
   sort?: Array<string>
}

export const getImageList = async ({ hotelId, sort, ...rest }: GetImageListRequest): Promise<Array<Image>> => {
   try {
      const result = await apiCall({
         url: `${process.env.REACT_APP_PUBLIC_CORE_API}/photos${hotelId? `/${hotelId}` :''}`,
         method: 'GET',
         params: { ...sort ? { sort: sort?.join(',') } : null, ...rest }
      })
      if (result.status !== 200) {
         throw new Error(`error ${result.status}`)
      }
      return result.data
   } catch (err) {
      return []
   }
}

type OptionProps = {
   hotelId?: number
   photos: FormData
}

export const uploadFile = async (request: OptionProps) => {
const { hotelId, photos } = request

   try {
      const endpoint = hotelId
         ? `${process.env.REACT_APP_PUBLIC_CORE_API}/photos/${hotelId}/uploadPhotos`
         : `${process.env.REACT_APP_PUBLIC_CORE_API}/photos/uploadPhotos`;
      return await apiCall({
         url: endpoint,
         method: 'POST',
         data: {
            photos: photos.get('photos'),
         },
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      })
   } catch (err) {
      console.log('Error uploading file: ', err)
   }
}